import React from 'react'
import { Button, Heading } from '@toasttab/shared/src/components'
import Eyebrow from '@toasttab/shared/src/components/molecules/Eyebrow/Eyebrow'
import Typography from '@toasttab/shared/src/components/atoms/Typography/Typography'
import { getImage } from '@toasttab/shared/src/utils/siteUtils'
import { useI18next } from '@toasttab/shared/src/hooks/useI18next'
import { resolvePrefix } from '@toasttab/shared/src/utils/assetUtils'

const PromoCTA = ({ promoBlock }: any) => {
  const { t } = useI18next()
  const blockImage = [getImage(promoBlock.blockImage)]

  /* Begin -- CTA Default State on Page Load */
  const melPictureCss = 'w-full md:w-[214px] text-left'
  /* End -- CTA Default State on Page Load */

  /* Begin -- Global promoBlock Template */
  const eyebrowIcon = {
    src: 'https://d2w1ef2ao9g8r9.cloudfront.net/otl-images/icon/icon-resource.svg',
    width: 14,
    height: 14,
    position: 'left'
  }
  /* End -- Global promoBlock Template */

  return (
    <div className='ds-grid px-4 py-4 md:py-5 mb-6 md:mb-0 mx-4 md:mx-8 lg:m-0 border-b border-gray-0 rounded-lg shadow-lg'>
      <div className='col-span-4 md:col-span-6 lg:col-span-12 flex flex-row block'>
        {blockImage && (
          <div className={`hidden md:block ${melPictureCss}`}>
            <picture className=''>
              {blockImage[0].optimizedImages.src !== '' && (
                <source
                  srcSet={blockImage[0].optimizedImages.src}
                  itemProp='image'
                  title={blockImage[0].title}
                />
              )}
              {blockImage[0].optimizedImages.srcsetWebp !== '' && (
                <source
                  srcSet={blockImage[0].optimizedImages.srcsetWebp}
                  sizes='100vw'
                  type='image/webp'
                />
              )}
              <img
                src={blockImage[0].url}
                alt={blockImage[0].title}
                itemProp='image'
                className='w-full lazyload'
              />
            </picture>
          </div>
        )}
        <div className='md:pl-6 flex-1'>
          <Eyebrow
            icon={eyebrowIcon}
            componentClass={`text-default text-xs tracking-[0.1em] mb-4`}
          >
            {promoBlock.blockLabel}
          </Eyebrow>

          {blockImage && (
            <div
              className={`flex md:hidden justify-center ${melPictureCss} mb-4`}
            >
              <picture className=''>
                {blockImage[0].optimizedImages.src !== '' && (
                  <source
                    srcSet={blockImage[0].optimizedImages.src}
                    itemProp='image'
                    title={blockImage[0].title}
                  />
                )}
                {blockImage[0].optimizedImages.srcsetWebp !== '' && (
                  <source
                    srcSet={blockImage[0].optimizedImages.srcsetWebp}
                    sizes='100vw'
                    type='image/webp'
                  />
                )}
                <img
                  src={blockImage[0].url}
                  alt={blockImage[0].title}
                  itemProp='image'
                  className='h-[140px] w-full lazyload object-contain'
                />
              </picture>
            </div>
          )}
          <Heading
            allowHtml
            heading='h3'
            content={promoBlock.blockTitle}
            fontFamily='font-calibre'
            fontWeight='font-semibold'
            fontSize={['text-xl', 'md:text-3xl']}
          />

          <Typography
            as='p'
            variation='default'
            classes={'font-sansPro text-base text-secondary my-4'}
            allowHtml={false}
          >
            {promoBlock.blockDescription.blockDescription}
          </Typography>

          <Button
            variation='primary'
            classes={'w-full md:w-auto mb-4'}
            href={promoBlock.blockLink}
          >
            <span className={`font-semibold`}>{promoBlock.blockCtaText}</span>
          </Button>

          <div className='block'>
            <img
              alt='Toast'
              className='h-[11px] inline'
              src={resolvePrefix('/svg/img-toast-logo.svg')}
            />
            <span className='text-xs text-brand-50 uppercase inline'>
              {' '}
              | {t('BUILT FOR RESTAURANTS')}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PromoCTA
